import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { Button, Card, Col, Row } from "react-bootstrap";
import storage from "utils/Storage";
import RangeCredit from "../../components/Game/Addons";
import { gameCoin } from "actions/gameCoin";
import { setPlay } from "actions/gamePlay";
import { setWallet } from "actions/gameWallet";
import { setClassicDiceResult } from "actions/gameResult";
import { Event, __, forceSatoshiFormat, isValidNumber, sendNotfication, wait, isMobile, playAudio } from 'utils/Helper';
import C from 'utils/Constant';
import { FiAlertCircle } from "react-icons/fi";

class Bet extends React.Component {
  _isMounted = false;
  constructor(props) {
    super(props);
    this.state = {
      engine: this.props.engine,
      started: false,
      bet: "manual",
      isLogged: storage.getKey("logged") !== null ? true : false,
      buttonText: "Roll",
      buttonType: "",
      amount: forceSatoshiFormat(
        storage.getKey("lam") ? storage.getKey("lam") : 50.00
      ),
      initialNumber: forceSatoshiFormat(
        storage.getKey("alam") ? storage.getKey("alam") : 50.00
      ),
      outError: false,
      inputDisabled: false,
      betNumber: 10,
      firstBetNumber: 10,
      onWin: 0,
      onLost: 0,
      isWin: false,
      stopOnWin: 0,
      type: "Under",
      coin: this.props.coin
        ? this.props.coin
        : storage.getKey("coin") !== null
        ? storage.getKey("coin")
        : "SOL",
    };
    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleBet = this.handleBet.bind(this);
  }

  componentDidMount() {
    if (this._isMounted) {
      let { engine } = this.state;

      wait(300).then(() => {
        if (isMobile()) {
          this.setState({ padding: "p-1" });
        }
      });

      this.props.gameCoin();
      engine.on(C.PLAY_CLASSIC_DICE, (data) => this.play(data));
      engine.on(C.BUSTED_CLASSIC_DICE, (data) => this.busted(data));
      engine.on(C.ERROR_CLASSIC_DICE, (data) => this.error(data));
      engine.on("stop_classic_dice", () => this.stopAuto());
      engine.on("stop_playing", () => this.stopManual());

      Event.on("change_type", (type) => {
        this.setState({ type: type });
      });
    }
  }

  componentWillMount() {
    this._isMounted = true;
  }

  componentWillUnmount() {
    let { engine } = this.state;
    engine.init = false;
    this._isMounted = false;
  }

  stopManual() {
    if (this._isMounted) {
      this.setState({
        started: false,
        buttonText: "Place Bet",
        inputDisabled: false,
      });
    }
  }

  stopAuto() {
    if (this._isMounted) {
      this.setState({
        started: false,
        buttonText: "Start Auto Mode",
        inputDisabled: false,
      });
    }
  }

  error(data) {
    if (this._isMounted) {
      sendNotfication(data.message, "info", "top-center");

      if (data.code === "credit") this.props.setWallet(true, data.uid);

      this.setState({
        inputDisabled: false,
        started: false,
        buttonText: "Roll",
      });
    }
  }

  play(data) {
    if (this._isMounted) {
      this.props.setClassicDiceResult(parseFloat(data.target));
      this.props.setPlay(true);
      playAudio("dice2.mp3");
    }
  }

  busted(data) {
    if (this._isMounted) {
      let { engine, bet, started } = this.state;
      this.setState({ inputDisabled: false });

      let isWinn = false;
      this.setState({ isWin: false });

      if (parseFloat(data.profit) >= 0) {
        isWinn = true;
        this.setState({ isWin: true });
      }

      if (bet === "auto") {
        if (started) {
          this.setState({ inputDisabled: true });
          // this.setState({ isWin: isWinn });
          engine.isWin = isWinn;
          engine.roundProfit =
            __.toNumber(data.profit) + __.toNumber(engine.roundProfit);
          this.placeAutoBet();
        }
      }

      if (isWinn) {
        playAudio("win.mp3");
        document.querySelector(
          ".dice-result span"
        ).style.background = `#35e179`;
        document.querySelector(".dice-result span").classList.add("add-sh");
        document.querySelector(".dice-result span").classList.remove("add-shg");
      } else {
        // playAudio('lost.mp3')
        document.querySelector(
          ".dice-result span"
        ).style.background = `#fd6638`;
        document.querySelector(".dice-result span").classList.add("add-shg");
        document.querySelector(".dice-result span").classList.remove("add-sh");
      }
    }
  }

  // placeAutoBet() {
  //   if (this._isMounted) {
  //     let {
  //       engine,
  //       amount,
  //       betNumber,
  //       firstBetNumber,
  //       onWin,
  //       onLost,
  //       stopOnWin,
  //       isWin,
  //       initialNumber,
  //     } = this.state;

  //     wait(1000).then(() => {
  //       console.log(isWin, "iswin");

  //       console.log("onwin state auto", onWin);

  //       console.log(parseFloat(amount), "amount");

  //       if (onWin != 0) {
  //         // It Mean Player has win in this round
  //         if (isWin) {
  //           var amountChange = amount * parseInt(onWin);
  //           this.setState((prevState) => ({
  //             amount: prevState.amount * parseInt(onWin),
  //           }));
  //           console.log("onWin amount:", amountChange);
  //         }
  //       }

  //       if (onLost != 0) {
  //         // It Mean Player has lost in this round
  //         if (!isWin) {
  //           // var amountChange = amount * parseInt(onLost);
  //           this.setState((prevState) => ({
  //             amount: prevState.amount * parseInt(onLost),
  //           }));
  //           console.log("onLose amount:", amountChange);
  //         } else if (isWin) {
  //           console.log(initialNumber, "initial");
  //           this.setState((prevState) => ({
  //             amount: prevState.initialNumber,
  //           }));
  //         }
  //       }

  //       amount = this.state.amount;

  //       engine.init = true;
  //       engine.amount = parseFloat(amount);
  //       engine.payout = this.props.classic_dice_payout;
  //       engine.chance = this.props.classic_dice_chance;
  //       engine.type = this.props.classic_dice_type;
  //       engine.coin = this.props.coin;
  //       engine.betNumber = firstBetNumber;
  //       engine.stopOnWin = parseInt(stopOnWin);
  //       engine.onWin = parseInt(onWin);
  //       engine.onLost = parseInt(onLost);
  //       engine.autoStart();
  //       this.setState({ betNumber: betNumber - 1 });
  //     });
  //   }
  // }

  placeAutoBet = () => {
    if (this._isMounted) {
      let {
        engine,
        amount, // The current bet amount
        betNumber, // Total number of bets
        onWin, // Percentage increase on win
        onLost, // Percentage increase on loss
        isWin, // Whether the current bet was a win
        initialNumber, // The initial bet amount
      } = this.state;

      // Delay for each bet
      wait(1000).then(() => {
        console.log("Current bet number:", betNumber);
        console.log("IsWin:", isWin);

        // If the user wins
        if (isWin) {
          // Reset to initial bet and apply onWin percentage if specified
          if (onWin !== 0) {
            const newAmount = initialNumber * (1 + parseFloat(onWin) / 100);
            this.setState({ amount: newAmount });
            console.log(
              `Win: Reset to initial amount and apply onWin percentage. New amount: ${newAmount}`
            );
          } else {
            // Just reset to the initial bet if no onWin percentage is set
            this.setState({ amount: initialNumber });
            console.log(
              `Win: Reset to initial amount. New amount: ${initialNumber}`
            );
          }
        } else {
          // If the user loses
          if (onLost !== 0) {
            const newAmount = amount * (1 + parseFloat(onLost) / 100);
            this.setState({ amount: newAmount });
            console.log(
              `Loss: Increase bet by onLost percentage. New amount: ${newAmount}`
            );
          }
        }

        // Decrease betNumber after each bet
        this.setState((prevState) => ({ betNumber: prevState.betNumber - 1 }));

        // Update engine with the new bet amount and other parameters
        const updatedAmount = this.state.amount;
        engine.init = true;
        engine.amount = parseFloat(updatedAmount);
        engine.payout = this.props.classic_dice_payout;
        engine.chance = this.props.classic_dice_chance;
        engine.type = this.props.classic_dice_type;
        engine.coin = this.props.coin;

        // Continue auto-betting if there are remaining bets
        if (this.state.betNumber > 0) {
          engine.autoStart(); // Continue the betting
        } else {
          console.log("Auto-betting has finished.");
          engine.trigger.emit("stop_classic_dice");
        }
      });
    }
  };

  placeBet() {
    if (this._isMounted) {
      let { engine, amount } = this.state;
      wait(500).then(() => {
        engine.init = true;
        engine.game = "classic_dice";
        engine.payout = this.props.classic_dice_payout;
        engine.chance = this.props.classic_dice_chance;
        engine.type = this.props.classic_dice_type;
        engine.amount = amount;
        engine.coin = this.props.coin;
        engine.start();
      });
    }
  }

  isCorrectBet(amount) {
    if (this._isMounted) {
      if (__.isUndefined(amount)) return;

      if (amount === "") return false;

      if (!isValidNumber(amount)) return false;

      if (parseFloat(amount) <= 0) {
        this.setState({ amount: forceSatoshiFormat(50.00) });
      } else {
        amount = Math.min(
          parseFloat(storage.getKey("credit")),
          parseFloat(amount)
        );
        this.setState({ amount: forceSatoshiFormat(amount) });
      }

      return true;
    }
  }

  handleBet(e) {
    if (this._isMounted) {
      e.preventDefault();

      let { bet, started, isLogged, amount } = this.state;

      this.setState({ initialNumber: amount });
      storage.setKey("alam", amount);
      console.log(this.state.initialNumber, "initial");

      // Check User
      if (!isLogged) {
        return Event.emit("showAuthModal", true);
      }

      // Check is Correct Bet
      if (!this.isCorrectBet(amount)) return false;

      this.setState({ inputDisabled: true });

      if (bet === "auto") {
        if (started) {
          this.setState({
            started: false,
            buttonText: "Start Auto Mode",
            inputDisabled: false,
          });
          return false;
        } else {
          this.setState({ started: true, buttonText: "Stop Auto Mode" });
          this.placeAutoBet();
        }
      } else {
        this.placeBet();
      }
    }
  }

  handleInputChange(event) {
    if (this._isMounted) {
      let target = event.target;
      let value = target.type === "checkbox" ? true : target.value;
      let name = target.name;

      if (name === "amount" || name === "stopOnWin") {
        this.setState({ amount: value });
        if (!isValidNumber(value)) return;
      }

      if (name === "amount") {
        storage.setKey("lam", value);
      } else {
        this.setState({ [name]: value });
      }
    }
  }

  betMode = (type) => {
    if (this._isMounted) {
      let text;

      if (type === "auto") {
        text = "Start Auto Mode";
      } else {
        text = "Roll";
      }
      this.setState({ bet: type, buttonText: text });
    }
  };

  setAmount = (val) => {
    var am = forceSatoshiFormat(val);
    this.setState({ amount: am });
    // if (this._isMounted) {
    //   e.preventDefault();
    //   this.setState({ initialNUmber: am });
    // }

    storage.setKey("lam", am);
  };

  handleDivideBy2 = () => {
    let currentAmount = parseFloat(this.state.amount);
    if (isNaN(currentAmount) || currentAmount <= 0) {
      currentAmount = 50.00;
    }
    let newAmount = currentAmount / 2;
    if (newAmount < 0.01) newAmount = 0.01;
    this.setAmount(newAmount);
  };

  handleMultiplyBy2 = () => {
    let currentAmount = parseFloat(this.state.amount);
    if (isNaN(currentAmount) || currentAmount <= 0) {
      currentAmount = 50.00;
    }
    let newAmount = currentAmount * 2;
    const maxWallet = parseFloat(storage.getKey("credit") || "0");
    if (newAmount > maxWallet) newAmount = maxWallet;
    this.setAmount(newAmount);
  };

  setNumber = (e, num) => {
    if (this._isMounted) {
      e.preventDefault();
      this.setState({ betNumber: num });
      this.setState({ firstBetNumber: num });
    }
  };

  render() {
    let { bet, inputDisabled, started, padding } = this.state;

    const withValueLimit = ({ floatValue }) => floatValue <= 1400;

    return (
      <>
        {this._isMounted && (
          <>
            <form
              className="w-100 mt-1 p-2"
              onSubmit={(e) => {
                e.preventDefault();
                if (this.props.coin === "INR") {
                  if (this.state.amount < 50) {
                    sendNotfication("Enter valid amount");
                  } else {
                    this.handleBet(e);
                  }
                } else if (this.props.coin === "USDT") {
                  if (this.state.amount < 1) {
                    sendNotfication("Enter valid amount");
                  } else {
                    this.handleBet(e);
                  }
                } else {
                  this.handleBet(e);
                }
              }}
            >
              <Row>
                <Col
                  sm={12}
                  className={"d-md-none d-sm-none"}
                  style={{ display: "none" }}
                >
                  {bet === "manual" && (
                    <Button
                      variant={
                        "btn btn-xs btn-block btn-bet py-2 mb-2 " +
                        this.state.buttonType
                      }
                      disabled={inputDisabled}
                      type="submit"
                    >
                      {this.state.buttonText}
                    </Button>
                  )}
                </Col>
                {/* header button */}

                <div
                  className="bet-option game-fonts"
                  style={{
                    display: "flex",
                    width: "100%",
                    justifyContent: "space-around",
                    padding: "2px 7px",
                    textAlign: "center",
                    alignItems: "center",
                    justifyItems: "center",
                    margin: "0px 4p",
                  }}
                >
                  {/* Manual */}
                  <div
                    className="btn-group btn-group-toggle my-1 ml-1"
                    data-toggle="buttons"
                    style={{
                      borderRadius: "2rem",
                      padding: "12px 45px",
                      backgroundColor:
                        bet === "manual" ? "#222328" : "transparent",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: bet === "manual" ? "white" : "gray",
                      border: bet === "manual" ? "" : "1px solid transparent",
                    }}
                    onClick={() => this.betMode("manual")}
                  >
                    Manual
                  </div>

                  {/* Auto */}
                  <div
                    style={{
                      borderRadius: "2rem",
                      padding: "12px 45px",
                      backgroundColor:
                        bet === "auto" ? "#222328" : "transparent",
                      cursor: "pointer",
                      fontSize: "14px",
                      color: bet === "auto" ? "white" : "gray",
                      border: bet === "auto" ? "" : "1px solid transparent",
                    }}
                    onClick={() => this.betMode("auto")}
                  >
                    Auto
                  </div>
                </div>

                {/* <div
              className="btn-group btn-group-toggle my-2 ml-1"
              data-toggle="buttons"
            >
              <label
                className={
                  "" + bet === "manual"
                    ? "btn bg-cs2 btn-xs active"
                    : "btn bg-cs2 btn-xs "
                }
              >
                <input
                  disabled={started}
                  onClick={(e) => this.betMode("manual")}
                  type="radio"
                />{" "}
                Manual
              </label>
              <label
                className={
                  "" + bet === "auto"
                    ? "btn bg-cs2 btn-xs active"
                    : "btn bg-cs2 btn-xs "
                }
              >
                <input
                  disabled={started}
                  onClick={(e) => this.betMode("auto")}
                  type="radio"
                />{" "}
                Auto
              </label>
            </div> */}

                <Col xl={12} md={12} sm={12}>
                  <div className={"form-group mb-1  bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Amount
                      <span
                        style={{
                          padding: "0px 3px",
                          color: "#3d9d0c",
                          fontSize: "15px", // Increase the icon size if needed
                          fontWeight: "bold", // Attempt to bolden icon by scaling
                          //   display: 'inline-flex',
                          alignItems: "center",
                        }}
                      >
                        <FiAlertCircle style={{ strokeWidth: 3 }} />{" "}
                        {/* Increase strokeWidth for a bolder look */}
                      </span>
                    </div>

                    <div className="input-group">
                      <div className="input-group-append input-radius-left">
                        <span
                          className="input-group-text "
                          style={{
                            borderRadius: "2rem 0 0 10px",
                            backgroundColor: "#222328",
                          }}
                        >
                          <img
                            src={"/assets/images/" + this.props.coin + ".png"}
                            className={"mini-coin-7"}
                            alt=""
                          />
                          {/* BET */}
                        </span>
                      </div>
                      <input
                        type="text"
                        disabled={inputDisabled}
                        className="form-control "
                        id="amount"
                        name="amount"
                        value={this.state.amount}
                        autoComplete={"off"}
                        onKeyUp={this.handleInputChange}
                        onChange={this.handleInputChange}
                        style={{
                          borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                          paddingLeft: "0px", // Optional: Ensure the padding inside the input is well spaced
                          backgroundColor: "#222328",
                        }}
                      />
                      <div
                        className="input-group-append"
                        style={{ display: "flex", gap: "1px" }}
                      >
                        <div
                          className="game-fonts"
                          onClick={this.handleDivideBy2}
                          style={{
                            width: "40px",
                            display: "flex",
                            backgroundColor: "#31343c",
                            alignItems: "center",
                            textAlign: "center",
                            justifyItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          /2
                        </div>
                        <div
                          className="game-fonts"
                          onClick={this.handleMultiplyBy2}
                          style={{
                            width: "40px",
                            backgroundColor: "#31343c",
                            alignItems: "center",
                            textAlign: "center",
                            display: "flex",
                            justifyItems: "center",
                            justifyContent: "center",
                            cursor: "pointer",
                          }}
                        >
                          x2
                        </div>
                        <RangeCredit set={this.setAmount} />
                      </div>
                    </div>
                  </div>
                </Col>
                <Col xl={12} md={12}>
                  <div className={"form-group mb-1 bet-input"}>
                    <div
                      style={{
                        color: "gray",
                        fontSize: "15px",
                        padding: "2px",
                        marginLeft: "12px",
                        justifyItems: "center",
                        alignItems: "center",
                      }}
                      className="game-fonts"
                    >
                      Win Amount
                    </div>
                    <div className="input-group">
                      <div className="input-group-append input-radius-left">
                        <span
                          className="input-group-text"
                          style={{
                            borderRadius: "2rem 0 0 10px",
                            backgroundColor: "#222328",
                          }}
                        >
                          <img
                            src={"/assets/images/" + this.props.coin + ".png"}
                            className={"mini-coin-7"}
                            alt=""
                          />
                          {/* WIN AMOUNT */}
                        </span>
                      </div>
                      <input
                        type="text"
                        style={{
                          backgroundColor: "#222328",
                          borderRadius: "0 0px 0px 0", // Rounded right side of the input field
                          paddingLeft: "0px",
                          borderTopRightRadius: "20px",
                          borderBottomRightRadius: "20px",
                        }}
                        disabled={true}
                        className="form-control"
                        value={forceSatoshiFormat(
                          this.props.classic_dice_payout
                            ? this.state.amount * this.props.classic_dice_payout
                            : 0.00000004
                        )}
                      />
                    </div>
                  </div>
                </Col>
              </Row>
              <div>
                <span style={{ fontSize: 11, marginLeft: 5 }}>
                  {this.props.coin === "INR"
                    ? "(Minimum Bet - 50 INR)"
                    : "(Minimum Bet - 1 USDT)"}
                </span>
              </div>

              {bet === "manual" && (
                <Row>
                  <Col xl={12} md={12} sm={12}>
                    <div className={"form-group rev mb-1  "}>
                      <Button
                        variant={
                          "btn btn-md btn-block mt-2 btn-bet " +
                          this.state.buttonType
                        }
                        disabled={inputDisabled}
                        type="submit"
                        style={{
                          // border: "2px solid red",
                          color: "#fff",
                          boxShadow:
                            "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                          // backgroundColor: "rgb(67, 179, 9)",
                          backgroundImage:
                            "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                          borderRadius: "10px",
                        }}
                      >
                        {this.state.buttonText}
                      </Button>
                    </div>
                  </Col>
                </Row>
              )}

              {bet === "auto" && (
                <>
                  <Row>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 mt-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Number of Bets
                        </div>
                        <div className="input-group input-radius-left">
                          <div className="input-group-append ">
                            {/* <span className="input-group-text" style={{ backgroundColor:"#222328"}}> */}
                            {/* Bets Num */}
                            {/* </span> */}
                          </div>
                          <input
                            style={{ backgroundColor: "#222328" }}
                            type="number"
                            disabled={inputDisabled}
                            className="form-control "
                            required={true}
                            value={this.state.betNumber}
                            onChange={(e) => this.setNumber(e, e.target.value)}
                          />
                          <div className="input-group-append">
                            <button
                              onClick={(e) => this.setNumber(e, 10)}
                              className={"btn btn-s-4 btn-xs"}
                              style={{ backgroundColor: "#31343c" }}
                            >
                              10
                            </button>
                            <button
                              onClick={(e) => this.setNumber(e, 50)}
                              className={"btn btn-s-4 btn-xs"}
                              style={{ backgroundColor: "#31343c" }}
                            >
                              50
                            </button>
                            <button
                              onClick={(e) => this.setNumber(e, 100)}
                              className={
                                "btn btn-s-4 btn-xs input-radius-right"
                              }
                              style={{ backgroundColor: "#31343c" }}
                            >
                              100
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Increase Amount On Win %
                        </div>
                        <div className="input-group input-radius-left">
                          <div className="input-group-append">
                            {/* <span className="input-group-text"> */}
                            {/* Increase Amount On Win % */}
                            {/* </span> */}
                          </div>
                          <input
                            style={{
                              backgroundColor: "#222328",
                            }}
                            disabled={inputDisabled}
                            type="number"
                            className="form-control"
                            name="onWin"
                            min="0"
                            autoComplete={"off"}
                            value={this.state.onWin}
                            onChange={(e) =>
                              this.setState({ onWin: e.target.value })
                            }
                          />
                          <div className="input-group-append ">
                            <button
                              className="btn bg-cs2 after-text no-hover npt nh input-radius-right"
                              type="button"
                              style={{
                                backgroundColor: "#31343c",
                              }}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Number of Bets
                        </div>
                        <div className="input-group input-radius-left">
                          <div className="input-group-append">
                            {/* <span className="input-group-text">
                              Increase Amount On Lost %
                            </span> */}
                          </div>
                          <input
                            style={{
                              backgroundColor: "#222328",
                            }}
                            disabled={inputDisabled}
                            type="number"
                            className="form-control"
                            name="onLost"
                            min="0"
                            autoComplete={"off"}
                            value={this.state.onLost}
                            onChange={(e) =>
                              this.setState({ onLost: e.target.value })
                            }
                          />
                          <div className="input-group-append">
                            <button
                              className="btn bg-cs2 after-text no-hover npt nh input-radius-right"
                              type="button"
                              style={{
                                backgroundColor: "#31343c",
                              }}
                            >
                              X
                            </button>
                          </div>
                        </div>
                      </div>
                    </Col>
                    <Col xl={12} md={12} sm={12}>
                      <div className={"form-group mb-1 bet-input"}>
                        <div
                          style={{
                            color: "gray",
                            fontSize: "15px",
                            padding: "2px",
                            marginLeft: "12px",
                            justifyItems: "center",
                            alignItems: "center",
                          }}
                          className="game-fonts"
                        >
                          Number of Bets
                        </div>
                        <div className="input-group input-radius-left">
                          <div className="input-group-append">
                            {/* <span className="input-group-text">
                              Stop On Win
                            </span> */}
                          </div>
                          <input
                            style={{
                              backgroundColor: "#222328",
                            }}
                            disabled={inputDisabled}
                            type="text"
                            className="form-control"
                            name="stopOnWin"
                            placeholder=".."
                            value={this.state.stopOnWin}
                            autoComplete={"off"}
                            onChange={this.handleInputChange}
                          />
                          <div className="input-group-append">
                            <div
                              className="input-group-text input-radius-right"
                              style={{
                                backgroundColor: "#31343c",
                              }}
                            >
                              <img
                                src={
                                  "/assets/images/" + this.props.coin + ".png"
                                }
                                className={"mini-coin-2 mr-1"}
                                alt=""
                              />
                              {this.props.coin}
                            </div>
                          </div>
                        </div>
                      </div>
                    </Col>
                  </Row>
                  <Row>
                    <Col md={12} className={"m-auto"}>
                      <Button
                        variant={"btn btn-md btn-block mt-2 btn-bet"}
                        type="submit"
                        style={{
                          // border: "2px solid red",
                          color: "#fff",
                          boxShadow:
                            "0px 0px 12px rgba(35, 238, 136, 0.3), 0px -2px rgb(29, 202, 106) inset",

                          // backgroundColor: "rgb(67, 179, 9)",
                          backgroundImage:
                            "linear-gradient(90deg, rgb(36, 238, 137), rgb(159, 232, 113))",
                          borderRadius: "10px",
                        }}
                      >
                        {this.state.buttonText}
                        {started && (
                          <>
                            <div
                              className={
                                "ml-2 spinner-border spinner-border-sm"
                              }
                            />
                          </>
                        )}
                      </Button>
                    </Col>
                  </Row>
                </>
              )}

              {/* manually option */}
              <div
                className="plingo-option mt-2 game-fonts"
                style={{
                  display: "flex",
                  width: "100%",
                  justifyContent: "space-around",
                  //  padding: "2px 5px",
                  textAlign: "center",
                  alignItems: "center",
                  justifyItems: "center",
                  margin: "0px 0px",

                  //    border:"2px solid yellow",
                  borderTop: "1px solid #222328",
                }}
              >
                {/* Manual */}
                {/* <div
                                    style={{
                                        borderRadius: "2rem",
                                     
                                        padding: "12px 45px",
                                        // borderBottom:bet === 'manual'?'2px solid red':'transparent',
                                        backgroundColor: bet === 'manual' ? '#222328' : 'transparent',
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: bet === 'manual' ? 'white' : 'gray',
                                        border: bet === 'manual' ? '' : '1px solid transparent',
                                        // border:"2px solid red"
                                    }}
                                    onClick={() => this.betMode('manual')}
                                >
                                    Manual
                                </div> */}

                {/* Manual */}
                <div
                  className={`manual-button ${
                    bet === "manual" ? "active" : ""
                  }`}
                  onClick={() => this.betMode("manual")}
                >
                  Manual
                  {/* <span className="arrow-icon">→</span> */}
                </div>

                {/* Auto */}
                {/* <div
                                    style={{
                                        borderRadius: "2rem",
                                        width:"100%",
                                        padding: "12px 45px",
                                        backgroundColor: bet === 'auto' ? '#222328' : 'transparent',
                                        cursor: "pointer",
                                        fontSize: "14px",
                                        color: bet === 'auto' ? 'white' : 'gray',
                                        border: bet === 'auto' ? '' : '1px solid transparent'
                                    }}
                                    onClick={() => this.betMode('auto')}
                                >
                                    Auto
                                </div> */}

                {/* Auto */}
                <div
                  className={`auto-button ${bet === "auto" ? "active" : ""}`}
                  onClick={() => this.betMode("auto")}
                >
                  Auto
                  {/* <span className="arrow-icon">→</span> */}
                </div>
              </div>
            </form>
          </>
        )}
      </>
    );
  }
}

Bet.propTypes = {
  coin: PropTypes.string,
  credit: PropTypes.string,
  classic_dice_payout: PropTypes.number,
  classic_dice_chance: PropTypes.number,
  classic_dice_type: PropTypes.string,
};

const mapStateToProps = (state) => ({
  coin: state.items.coin,
  credit: state.items.credit,
  classic_dice_payout: state.items.classic_dice_payout,
  classic_dice_chance: state.items.classic_dice_chance,
  classic_dice_type: state.items.classic_dice_type,
});

export default connect(mapStateToProps, {
  setPlay,
  gameCoin,
  setClassicDiceResult,
  setWallet,
})(Bet);
